import apiClient from './client';
import type { CreateLinkPayload, UpdateLinkPayload } from '@/types/link.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ApiLink = any;

export const linksApi = {
  listByCanvas: async (canvasId: string): Promise<ApiLink[]> => {
    const { data } = await apiClient.get<ApiLink[]>('/links', { params: { canvasId } });
    return data;
  },

  getById: async (linkId: string): Promise<ApiLink> => {
    const { data } = await apiClient.get<ApiLink>(`/links/${linkId}`);
    return data;
  },

  create: async (payload: CreateLinkPayload): Promise<ApiLink> => {
    const { data } = await apiClient.post<ApiLink>('/links', payload);
    return data;
  },

  update: async (linkId: string, payload: UpdateLinkPayload): Promise<ApiLink> => {
    const { data } = await apiClient.patch<ApiLink>(`/links/${linkId}`, payload);
    return data;
  },

  delete: async (linkId: string): Promise<void> => {
    await apiClient.delete(`/links/${linkId}`);
  },
};

export default linksApi;
